import { create } from 'zustand';

import type { TrialVariant } from '../lib/types';

type TrialVariantAssignment = {
  userId: string;
  variant: TrialVariant;
};

type TrialVariantStore = {
  assignment: null | TrialVariantAssignment;
  setAssignment: (assignment: TrialVariantAssignment) => void;
};

export const useTrialVariantStore = create<TrialVariantStore>((set) => ({
  assignment: null,
  setAssignment: (assignment) => set({ assignment }),
}));
